import { render, staticRenderFns } from "./FormCancellationReason.vue?vue&type=template&id=7679bc22"
import script from "./FormCancellationReason.vue?vue&type=script&lang=js"
export * from "./FormCancellationReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports